import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { getSuggestionStyles } from './utils';
import { SuggestionInnerContent } from './internal/SuggestionInnerContent';
import { jsx as _jsx } from "react/jsx-runtime";
var SuggestionContent = function SuggestionContent(props) {
  var item = props.item,
    selected = props.selected,
    onClick = props.onClick,
    onMouseOver = props.onMouseOver,
    inputType = props.inputType,
    onLinkClick = props.onLinkClick,
    forwardRef = props.forwardRef,
    itemsTruncation = props.itemsTruncation;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles.apply(void 0, _toConsumableArray(getSuggestionStyles(item, selected)))), {}, {
    onClick: onClick,
    onMouseOver: onMouseOver,
    //удалил реактовский forwardRef из-за несовместимости версий
    ref: forwardRef,
    children: /*#__PURE__*/_jsx(SuggestionInnerContent, {
      item: item,
      inputType: inputType,
      onLinkClick: onLinkClick,
      itemsTruncation: itemsTruncation
    })
  }));
};
export var Suggestion = /*#__PURE__*/function (_React$Component) {
  _inherits(Suggestion, _React$Component);
  var _super = _createSuper(Suggestion);
  function Suggestion(props) {
    var _this;
    _classCallCheck(this, Suggestion);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(Suggestion, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      this.setState({
        hasError: true
      });

      // TODO: https://cianru.atlassian.net/browse/CD-50613
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return null;
      }
      return /*#__PURE__*/_jsx(SuggestionContent, _objectSpread({}, this.props));
    }
  }]);
  return Suggestion;
}(React.Component);